import { Copy } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCopy12Line = createIcon(Copy, 12, "Line");
export const IconCopy16Line = createIcon(Copy, 16, "Line");
export const IconCopy20Line = createIcon(Copy, 20, "Line");
export const IconCopy24Line = createIcon(Copy, 24, "Line");
export const IconCopy32Line = createIcon(Copy, 32, "Line");
export const IconCopy48Line = createIcon(Copy, 48, "Line");
export const IconCopy64Line = createIcon(Copy, 64, "Line");
